/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Ref } from "react";
import { TextareaAutosize } from "@material-ui/core";
import { noop } from "../../../../globalConsts";
import { DEFAULT_TEXTAREA_CONFIG } from "../FlowioInput/constants";

type ControlledOnlyProps = {
  value: string | number;
  defaultValue?: undefined;
  inputRef?: undefined;
};
type UncontrolledOnlyProps = {
  value?: undefined;
  defaultValue: string | number;
  inputRef: Ref<any>;
};
type RefControlledOnlyProps = {
  value?: undefined;
  defaultValue?: undefined;
  inputRef: Ref<any>;
};

type Config = { minLength?: number | string; maxLength?: number | string };
type CommonProps = {
  onChange?: (v: string) => void;
  onBlur?(): void;
  inputRef?: Ref<any>;
  config?: Config;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  id?: string;
  className?: string;
  onClick?: () => void;
  autoSize?: boolean;
};

type Props = (
  | ControlledOnlyProps
  | UncontrolledOnlyProps
  | RefControlledOnlyProps
) &
  CommonProps;

const FlowioTextarea: FC<Props> = ({
  value,
  defaultValue,
  onChange = noop,
  onBlur,
  inputRef,
  placeholder,
  disabled = false,
  config = DEFAULT_TEXTAREA_CONFIG,
  name,
  id,
  onClick = noop,
  required = false,
  className,
  autoSize = true,
}) => {
  const { minLength, maxLength } = config;

  const getLengthAsNumber = (
    num: string | number | undefined,
    method: "min" | "max"
  ) => {
    switch (typeof num) {
      case "number":
        return num;
      case "string":
        return parseInt(num);
      case "undefined":
        return method === "max" ? 255 : 0;

      default:
        return method === "max" ? 255 : 0;
    }
  };

  if (!autoSize) {
    return (
      <textarea
        value={value}
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        className={className}
        name={name}
        onClick={onClick}
        id={id}
        data-cy="input flowio-textarea"
        ref={inputRef}
        maxLength={getLengthAsNumber(maxLength, "max")}
        minLength={getLengthAsNumber(minLength, "min")}
      />
    );
  }

  return (
    <TextareaAutosize
      data-cy="input flowio-textarea flowio-textarea--autorize"
      minRows={minLength}
      maxRows={maxLength}
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      className={className}
      maxLength={getLengthAsNumber(maxLength, "max")}
      minLength={getLengthAsNumber(minLength, "min")}
      name={name}
      onClick={onClick}
      id={id}
      ref={inputRef}
    />
  );
};

export default FlowioTextarea;
export type FlowioTextareaProps = Props;
export type FlowioTextareaCommonProps = CommonProps;
